<template>
  <HeaderLabels :labels="labels" @update="$emit('update', $event)" />
</template>

<script>
import { textLabel, selectLabel } from '@/reusable/header-labels/labels'
// Libraries
import { mapState, mapGetters } from 'vuex'
// Components
import HeaderLabels from '@/reusable/header-labels/HeaderLabels'

export default {
  components: {
    HeaderLabels
  },

  props: {
    provider: {
      type: Object,
      required: true
    },

    createData: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('provider-show', ['contacts']),
    ...mapGetters('provider-show', ['primaryContact']),

    labels() {
      const { provider, createData } = this
      const currencies = this.currencies.map(c => ({ id: c.value, name: c.label }))

      return [
        {
          section: true,
          items: [
            textLabel(provider, 'Abbreviation', 'abbreviation'),
            textLabel(provider, 'Alternative name', 'alternative_name'),
            selectLabel(provider, 'Currency', 'currency', 'currency', 'currency', currencies)
          ]
        },

        { separator: true },

        {
          section: true,
          items: [
            textLabel(provider, 'Website', 'website', {
              link: true,
              to: provider.website,
              newTab: true,
              absoluteUrl: true
            }),

            selectLabel(provider, 'License manager', 'owner.name', 'owner_id', 'owner.id', createData.owners),
            {
              label: 'Primary contact:',
              value: this.primaryContact
                ? `${this.primaryContact.first_name} ${this.primaryContact.last_name || ''}`
                : null,
              editable: {
                field: 'is_primary',
                title: `Update primary contact`,
                type: 'select',
                value: this.primaryContact?.id || 0,
                options: [
                  { id: 0, name: 'None' },
                  ...this.contacts.map(c => ({ id: c.id, name: `${c.first_name} ${c.last_name || ''}` }))
                ]
              }
            }
          ]
        },

        { separator: true },

        {
          section: true,
          items: [
            textLabel(provider, 'Customer account number', 'customer_account_number'),
            textLabel(provider, 'Ringgold ID', 'ringgold_id')
          ]
        }
      ]
    }
  }
}
</script>
